export enum EditionModeRef {
  creation = 'creation',
  edition = 'edition'
}
